var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-container" }, [
    _c("div", {
      staticClass: "background-container",
      class: _vm.showCastle === true ? "hogwarts" : "smoke"
    }),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { key: "load", staticClass: "content loading" }, [
          _c("h1", [_vm._v("Loading...")])
        ])
      : _c(
          "div",
          {
            key: "content",
            staticClass: "content",
            class: [{ vertical: _vm.vertical }, _vm.contentClass]
          },
          [_vm._t("default")],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }